/** Stripe Price IDs — base, maintenance, support (monthly & 3-year prepay). */

export const stripePriceIds: Record<string, string> = {
  small: "price_1T288GRojWIVDFbP4qiXDYNf",
  medium: "price_1T27reRojWIVDFbPUm31ursA",
  "large-medium": "price_1TWI3cRojWIVDFbPrkkog8Nv",
  large: "price_1TWZ02RojWIVDFbPYxqBhbnP",
};

export const stripePriceIdsPrepay3Year: Record<string, string> = {
  small: "price_1TRuA2RojWIVDFbPlltVuwCB",
  medium: "price_1TRtrtRojWIVDFbPtfHtFBZa",
  "large-medium": "price_1TWZ3bRojWIVDFbPp3jxOlhD",
  large: "price_1TWZ6ORojWIVDFbPFOWqQv5s",
};

export const stripeMaintenancePriceIds: Record<string, string> = {
  small: "price_1T289bRojWIVDFbPajTBxDhQ",
  medium: "price_1T27sdRojWIVDFbPiKTqaUjZ",
  "large-medium": "price_1TWYyuRojWIVDFbPtC3PNs8J",
  large: "price_1TWZ0eRojWIVDFbP4wDr5ZcO",
};

export const stripeMaintenancePriceIdsPrepay3Year: Record<string, string> = {
  small: "price_1TWHaWRojWIVDFbPVEjpYvlb",
  medium: "price_1TWHnHRojWIVDFbP6e2zu2IA",
  "large-medium": "price_1TWZ5hRojWIVDFbPxNBp1Zuo",
  large: "price_1TWZ7IRojWIVDFbPofGRpjJs",
};

export const stripeSupportPriceIds: Record<string, string> = {
  small: "price_1T28AFRojWIVDFbPbmiXab42",
  medium: "price_1T27tRRojWIVDFbP77qYXf8q",
  "large-medium": "price_1TWYzNRojWIVDFbPYg9uLBsL",
  large: "price_1TWZ1RRojWIVDFbPLYfToBil",
};

export const stripeSupportPriceIdsPrepay3Year: Record<string, string> = {
  small: "price_1TWHbgRojWIVDFbPYO2PtTSv",
  medium: "price_1TWHoZRojWIVDFbPLoaV2YpM",
  "large-medium": "price_1TWZ4nRojWIVDFbP3ndiuZyf",
  large: "price_1TWZ82RojWIVDFbPA4zp8wLZ",
};
